import { render } from "./RegulatoryIntelligence.vue?vue&type=template&id=4878299e&scoped=true"
import script from "./RegulatoryIntelligence.vue?vue&type=script&lang=js"
export * from "./RegulatoryIntelligence.vue?vue&type=script&lang=js"

import "./RegulatoryIntelligence.vue?vue&type=style&index=0&id=4878299e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4878299e"]])

export default __exports__